/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#setInternalAnnotationsTransform__anchor
 */
export default callback => {
  window.documentViewer.setInternalAnnotationsTransform(callback);
};
